import { http } from '@/api/http'
import type { BranchScope, MeContext, MeProfile, UserIdentity } from '@/types/api'

export const meService = {
  /** The frontend bootstrap contract: profile, branches, capabilities, resources, field access. */
  async context() {
    const { data } = await http.get<MeContext>('/me/context')
    return {
      ...data,
      branches: data.branches ?? [],
      capabilities: data.capabilities ?? [],
      resources: data.resources ?? [],
      field_access: data.field_access ?? {},
      menu: data.menu ?? [],
      hidden_controls: data.hidden_controls ?? [],
    }
  },
  /** The signed-in profile as /me/profile returns it; the header takes its photo from here. */
  async profile() {
    const { data } = await http.get<MeProfile>('/me/profile')
    return data
  },
  /** The own user card («Мой профиль»): no Users right needed. */
  async account() {
    const { data } = await http.get<UserIdentity>('/me/account')
    return data
  },
  /** Saves the own card; only the sent fields change. A changed login ends every session. */
  async updateAccount(body: { display_name?: string; login?: string; avatar_url?: string }) {
    const { data } = await http.patch<UserIdentity>('/me/account', body)
    return data
  },
  /** Changes the own password after the current one is checked; every session ends. */
  async changePassword(currentPassword: string, newPassword: string) {
    await http.post('/me/password', { current_password: currentPassword, new_password: newPassword })
  },
  /**
   * The branches whose rows the caller's grants of one permission show
   * (all = no branch restriction). Report pages narrow their branch filter
   * with it; the report API enforces the same scope itself.
   */
  async branchScope(permission: string, options?: { signal?: AbortSignal }): Promise<BranchScope> {
    const { data } = await http.get<BranchScope>('/me/branch-scope', { params: { permission }, ...options })
    return { all: Boolean(data.all), branch_ids: data.branch_ids ?? [] }
  },
}
